import { render, staticRenderFns } from "./IdleIndicatorMessage.vue?vue&type=template&id=28ee078b"
import script from "./IdleIndicatorMessage.vue?vue&type=script&lang=js"
export * from "./IdleIndicatorMessage.vue?vue&type=script&lang=js"
import style0 from "./IdleIndicatorMessage.vue?vue&type=style&index=0&id=28ee078b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports